import React from 'react';
import { AnswerStatus, ReduxState } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import './answerCard.style.scss';
import { Link, useParams } from 'react-router-dom';
import { __AnswerCardprops } from './answerCard.interface';
import { RoutePath } from 'data';

const AnswerCard: React.FC<ConnectedProps<typeof connector> & __AnswerCardprops> = function (
    props: ConnectedProps<typeof connector> & __AnswerCardprops,
) {
    const lang = props.lang.publishDetail.answerList.answerCard;
    const data = props.data;
    const { publish, form } = useParams<any>();
    // console.log(props.user);

    return (
        <Link to={RoutePath.dashboard.answerDetail(publish, form, data.id)} className="ucheck-kiosk-answer-card">
            <p className="code">
                <span>
                    {lang.answer + ' ' + props.user?.id + '-' + props.publishData?.form.id + '-' + data.id}
                </span>
                {data.questionerOffline ? (
                    <i className="material-icons offline">cloud_off</i>
                ) : (
                    <i className="material-icons">cloud</i>
                )}
            </p>
            <div className="end-line">
                {data.state === AnswerStatus.complete ? (
                    <div className="first">
                        <i className="material-icons complete">check_circle_outline</i>
                        <p>{lang.complete}</p>
                    </div>
                ) : (
                    <div className="first">
                        <i className="material-icons in-complete">highlight_off</i>
                        <p>{lang.inComplete}</p>
                    </div>
                )}
                <span />
                <div className="second">
                    <i className="material-icons">schedule</i>
                    <p>{new Date(data.created_at).toLocaleString('fa')}</p>
                </div>
            </div>
        </Link>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
    user: state.userData,
    publishData: state.publishData,
});

const connector = connect(mapStateToProps);
export default connector(AnswerCard);
